import { Capacitor } from '@capacitor/core';

export const useIsNativePlatform = () => Capacitor.isNativePlatform() || localStorage.getItem('__simulateNative') === 'true';
